import { IRootState } from 'reducers';

export const currentStudentSelector = (state: IRootState) => state.currentStudent;

export const currentStudentMeshIdSelector = (state: IRootState) => currentStudentSelector(state).meshId;
